import { useState } from 'react';
import { Link } from 'react-router-dom';
import apiClient from '../api/apiClient';
import Logo from '../components/common/Logo';

const ForgotPassword = () => {
    const [email, setEmail] = useState('');
    const [submitted, setSubmitted] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const onSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');

        try {
            await apiClient.post('/auth/forgot-password', { email });
            setSubmitted(true);
        } catch (err) {
            const message =
                err.response?.data?.message || 'Une erreur est survenue. Veuillez réessayer.';
            setError(message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="auth-container page-transition">
            <div className="auth-card">
                {submitted ? (
                    <>
                        <div style={{ textAlign: 'center', marginBottom: '20px' }}>
                            <div style={{ fontSize: '48px', marginBottom: '16px' }}>&#9993;</div>
                            <h1 className="auth-title">Email envoyé</h1>
                            <p className="auth-subtitle">
                                Si un compte existe avec cet email, vous recevrez un lien de
                                réinitialisation dans quelques instants.
                            </p>
                        </div>
                        <p style={{ textAlign: 'center', color: 'var(--text-muted)', fontSize: '14px', marginBottom: '20px' }}>
                            Pensez à vérifier vos spams si vous ne voyez pas l'email.
                        </p>
                        <Link
                            to="/login"
                            className="btn btn-primary"
                            style={{ width: '100%', padding: '15px', display: 'block', textAlign: 'center', textDecoration: 'none' }}
                        >
                            Retour à la connexion
                        </Link>
                    </>
                ) : (
                    <>
                        <div style={{ textAlign: 'center', marginBottom: '10px' }}>
                            <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '12px' }}>
                                <Logo size="large" showText={false} variant="auth" />
                            </div>
                            <p className="auth-subtitle">
                                Entrez votre adresse email pour recevoir un lien de réinitialisation.
                            </p>
                        </div>

                        {error && (
                            <div style={{
                                background: 'var(--urgent, #E63946)',
                                color: 'white',
                                padding: '12px 16px',
                                borderRadius: '8px',
                                marginBottom: '16px',
                                fontSize: '14px'
                            }}>
                                {error}
                            </div>
                        )}

                        <form onSubmit={onSubmit}>
                            <div className="input-group">
                                <label className="input-label" htmlFor="email">Email</label>
                                <input
                                    type="email"
                                    className="input-field"
                                    id="email"
                                    name="email"
                                    value={email}
                                    placeholder="Entrez votre email"
                                    onChange={(e) => setEmail(e.target.value)}
                                    required
                                />
                            </div>

                            <button
                                type="submit"
                                className="btn btn-primary"
                                style={{ width: '100%', padding: '15px', marginBottom: '16px' }}
                                disabled={loading}
                            >
                                {loading ? 'Envoi en cours...' : 'Envoyer le lien'}
                            </button>
                        </form>

                        <div className="auth-footer" style={{ textAlign: 'center' }}>
                            <Link to="/login" style={{ color: 'var(--primary)', textDecoration: 'none' }}>
                                Retour à la connexion
                            </Link>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};

export default ForgotPassword;
